/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { editorCreateExhibition } from '../fn/editor-exhibitions-controller/editor-create-exhibition';
import { EditorCreateExhibition$Params } from '../fn/editor-exhibitions-controller/editor-create-exhibition';
import { editorDeleteExhibition } from '../fn/editor-exhibitions-controller/editor-delete-exhibition';
import { EditorDeleteExhibition$Params } from '../fn/editor-exhibitions-controller/editor-delete-exhibition';
import { editorGetExhibition } from '../fn/editor-exhibitions-controller/editor-get-exhibition';
import { EditorGetExhibition$Params } from '../fn/editor-exhibitions-controller/editor-get-exhibition';
import { editorGetExhibitions } from '../fn/editor-exhibitions-controller/editor-get-exhibitions';
import { EditorGetExhibitions$Params } from '../fn/editor-exhibitions-controller/editor-get-exhibitions';
import { editorUpdateExhibition } from '../fn/editor-exhibitions-controller/editor-update-exhibition';
import { EditorUpdateExhibition$Params } from '../fn/editor-exhibitions-controller/editor-update-exhibition';
import { Exhibition } from '../models/exhibition';
import { ExhibitionWithRelations } from '../models/exhibition-with-relations';

@Injectable({ providedIn: 'root' })
export class EditorExhibitionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exhibitionControllerEditorGetExhibition()` */
  static readonly ExhibitionControllerEditorGetExhibitionPath = '/editor/exhibitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetExhibition()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetExhibition$Response(params: EditorGetExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitionWithRelations>> {
    return editorGetExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetExhibition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetExhibition(params: EditorGetExhibition$Params, context?: HttpContext): Observable<ExhibitionWithRelations> {
    return this.editorGetExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExhibitionWithRelations>): ExhibitionWithRelations => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerEditorUpdateExhibition()` */
  static readonly ExhibitionControllerEditorUpdateExhibitionPath = '/editor/exhibitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorUpdateExhibition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdateExhibition$Response(params: EditorUpdateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorUpdateExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorUpdateExhibition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdateExhibition(params: EditorUpdateExhibition$Params, context?: HttpContext): Observable<any> {
    return this.editorUpdateExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerEditorGetExhibitions()` */
  static readonly ExhibitionControllerEditorGetExhibitionsPath = '/editor/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetExhibitions()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetExhibitions$Response(params?: EditorGetExhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitionWithRelations>>> {
    return editorGetExhibitions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetExhibitions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetExhibitions(params?: EditorGetExhibitions$Params, context?: HttpContext): Observable<Array<ExhibitionWithRelations>> {
    return this.editorGetExhibitions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ExhibitionWithRelations>>): Array<ExhibitionWithRelations> => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerEditorCreateExhibition()` */
  static readonly ExhibitionControllerEditorCreateExhibitionPath = '/editor/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorCreateExhibition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreateExhibition$Response(params?: EditorCreateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<Exhibition>> {
    return editorCreateExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorCreateExhibition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreateExhibition(params?: EditorCreateExhibition$Params, context?: HttpContext): Observable<Exhibition> {
    return this.editorCreateExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Exhibition>): Exhibition => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerEditorDeleteExhibition()` */
  static readonly ExhibitionControllerEditorDeleteExhibitionPath = '/editor/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorDeleteExhibition()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeleteExhibition$Response(params: EditorDeleteExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorDeleteExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorDeleteExhibition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeleteExhibition(params: EditorDeleteExhibition$Params, context?: HttpContext): Observable<any> {
    return this.editorDeleteExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
